import React, { useEffect, useState } from 'react';
export function ScrollProgressBar() {
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      // Calculate scroll percentage
      const totalScrollableHeight = documentHeight - windowHeight;
      const progress = scrollTop / totalScrollableHeight * 100;
      setScrollProgress(Math.min(progress, 100));
    };
    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);
    // Call once to set initial state
    handleScroll();
    // Cleanup
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-50 h-1 bg-gray-200" data-id="element-363">
      <div className="h-full bg-gradient-to-r from-purple-600 via-indigo-600 to-purple-600 transition-all duration-150 ease-out" style={{
      width: `${scrollProgress}%`
    }} data-id="element-364" />
    </div>;
}